export default __webpack_public_path__ + "static/assets/9a851b78b248793cbb8bfd29aa8f79d9.png";